import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=31119e9a&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"
import style0 from "./examination.vue?vue&type=style&index=0&id=31119e9a&prod&lang=scss&scoped=true"
import style1 from "./examination.vue?vue&type=style&index=1&id=31119e9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31119e9a",
  null
  
)

export default component.exports